import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
const ErrorMessage = ({ message }) => {
    return message ? (_jsx(Typography, { variant: "body2", color: "error", mt: 1, style: { color: 'red' }, children: message })) : null;
};
export default ErrorMessage;
